import { render, staticRenderFns } from "./DemoLogin.vue?vue&type=template&id=5111803e&scoped=true"
import script from "./DemoLogin.vue?vue&type=script&lang=ts"
export * from "./DemoLogin.vue?vue&type=script&lang=ts"
import style0 from "./DemoLogin.vue?vue&type=style&index=0&id=5111803e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5111803e",
  null
  
)

export default component.exports